import { useMemo } from 'react';
import { Colors } from '@mercator-gcp/grout';
import { Marker } from '@react-google-maps/api';

type Props = {
  clusterKey: string;
  lat: number;
  lng: number;
  label: string;
  onClick: () => void;
  isActive?: boolean;
};

const MapCluster = ({ clusterKey, lat, lng, label, onClick, isActive }: Props) => {
  const iconUrl = useMemo(() => {
    return isActive ? '/map-cluster--active.svg' : '/map-cluster.svg';
  }, [isActive]);

  const clusterIconSettings = useMemo(() => {
    let size;
    switch (label.length) {
      case 1:
      case 2:
        size = {
          scaledSize: new google.maps.Size(30, 30),
          anchor: new google.maps.Point(15, 15),
        };
        break;
      case 3:
        size = {
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 20),
        };
        break;
      case 4:
        size = {
          scaledSize: new google.maps.Size(50, 50),
          anchor: new google.maps.Point(25, 25),
        };
        break;
      case 5:
        size = {
          scaledSize: new google.maps.Size(60, 60),
          anchor: new google.maps.Point(30, 30),
        };
        break;
      default:
        size = {
          scaledSize: new google.maps.Size(78, 78),
          anchor: new google.maps.Point(39, 39),
        };
    }

    return {
      url: iconUrl,
      ...size,
    };
  }, [label, iconUrl]);

  return (
    <Marker
      key={clusterKey}
      position={{ lat, lng }}
      label={{
        text: label,
        fontWeight: '600',
        fontSize: '12px',
        color: isActive ? Colors.Tangerine900 : Colors.ArmyGreen900,
      }}
      icon={clusterIconSettings}
      onClick={onClick}
    />
  );
};

export default MapCluster;
